import { useRef } from 'react';

// Guards an in-flight request so only the most recent call's handlers run.
// Each invocation supersedes earlier ones: a stale resolution/rejection (a
// response that arrives after a newer request was issued) is dropped. Used by
// the dashboard and report builder, which both fire overlapping fetches as the
// user changes filters.
const useLatestRequest = () => {
  const latestRequestIdRef = useRef(0);

  return ({
    request,
    onResolve,
    onReject,
    onFinally,
  }) => {
    const requestId = latestRequestIdRef.current + 1;
    latestRequestIdRef.current = requestId;
    const isCurrent = () => latestRequestIdRef.current === requestId;

    request()
      .then((response) => {
        if (isCurrent()) onResolve?.(response);
      })
      .catch((error) => {
        if (isCurrent()) onReject?.(error);
      })
      .finally(() => {
        if (isCurrent()) onFinally?.();
      });
  };
};

export default useLatestRequest;
